import { darken, Grid, lighten } from '@mui/material';
import { FC } from 'react';
import { fileColumns } from '@/components/FileManager/FilesContainer/FolderContent/FolderContent';
import styled from '@emotion/styled';

const FolderColumns: FC = () => {
  return (
    <ColumnsWrapper container>
      {fileColumns.map((column, i) => (
        <Grid item key={i} style={{ width: column.width, paddingLeft: column.paddingLeft || 0, textAlign: column.textAlign || 'left' }}>
          {column.name}
        </Grid>
      ))}
    </ColumnsWrapper>
  );
};

export default FolderColumns;

const ColumnsWrapper = styled(Grid)`
  padding: 8px 16px;
  border-bottom: 1px solid ${({ theme }) => (theme.palette.mode === 'dark' ? lighten(theme.palette.divider, 1) : darken(theme.palette.divider, 0.4))};
  opacity: 0.5;
  column-gap: ${({ theme }) => theme.spacing(1)};
`;
